<script setup lang="ts">
import {ChevronDownIcon, ChevronUpIcon} from 'lucide-vue-next'
import {ref, type Ref} from "vue";
import {type DomainResponse} from "../../responses/DomainResponse";

interface Props {
    domains: DomainResponse[]
}
const props = defineProps<Props>();
const toggled: Ref<boolean> = ref(false);
</script>

<template>
    <div>
        <a href="javascript:" @click="toggled = !toggled;" class="relative flex rounded-lg h-10 lg:h-12 px-2 lg:px-4 w-full justify-center items-center border border-gray-200">
            <svg class="w-9 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6"><path fill="#21468B" d="M0 0h9v6H0z"/><path fill="#FFF" d="M0 0h9v4H0z"/><path fill="#AE1C28" d="M0 0h9v2H0z"/></svg>
            <ChevronDownIcon v-if="!toggled" class="h-4 w-5 ml-2"></ChevronDownIcon>
            <ChevronUpIcon v-else class="h-4 w-5 ml-2"></ChevronUpIcon>
        </a>

        <ul v-show="toggled" class="bg-white divide-y divide-solid divide-gray-200 w-full absolute z-40 left-0 top-14 shadow text-sm">
            <li v-for="domain in domains">
                <a :href="domain.url" class="flex text-gray-500 hover:text-black hover:font-medium cursor-pointer px-3 py-3">
                    <span>
                        {{ domain.lang }}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>
